import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { useUser } from "../../../DataProvider";
import Search from "antd/es/input/Search";

type Props = {};

const HeaderNav = (props: Props) => {
  const { logout } = useUser();
  return (
    <div className=" flex flex-row justify-between items-center space-x-2">
      <Button onClick={logout} title="Logout" shape="circle">
        <LogoutOutlined />
      </Button>
    </div>
  );
};

export default HeaderNav;
